import axios from "axios";
import ApiException from "./ApiException";
import config from "@/app.config.json";
import { getToken } from "@/utils/funcoes";

const urlBase = `${config.urlApi}/Logs`;

export interface Filtros {
  usuarioId?: number | null;
  clienteId?: number | null;
  pesquisar?: string | null;
  dataInicio?: string | null;
  dataFim?: string | null;
  paginaAtual?: number;
  tamanhoPagina?: number;
}

export interface Log {
  id: number;
  data: string;
  tipo: string;
  descricao: string;
  local: string | null;
  usuarioId: number | null;
  usuarioNome: string | null;
  clienteId: number | null;
  clienteNome: string | null;
  empresaId: number | null;
  empresaNome: string | null;
}

export interface RetornoGrid {
  totalRegistros: number;
  dados: Log[];
}

export const obter = (filtros: Filtros): Promise<RetornoGrid> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios.get(urlBase, { params: filtros })
      .then(r => resolve(r.data))
      .catch(e => reject(new ApiException(e || "Falha ao obter logs")));
  });
};
